import React, { useEffect, useState } from "react";
import "./SectorPerformance.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";
import FOTopGainerLooser from "../fo-top-gainer-looser/FOTopGainerLooser";

export default function SectorPerformance() {

    // WebSocket connection
    const { sectorialIndicesData, strategyIndicesData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [sectorData, setSectorData] = useState([]);
    const [chartData, setChartData] = useState([]);

    /* ================== DATA MAPPING ================== */
    const buildSectorChartData = (data) => {
        if (!Array.isArray(data)) return [];

        const formatted = data.map((item) => ({
            name: item.index
                ?.replace("NIFTY ", "")
                ?.replace("SECTOR ", "")
                ?.trim(),
            value: parseFloat(item.pChange) || 0,
            animatedHeight: 0 // 🔥 initial height = 0
        }));

        return formatted.sort((a, b) => b.value - a.value);
    };

    /* ================== EFFECT ================== */
    useEffect(() => {
        if (Array.isArray(sectorialIndicesData) && sectorialIndicesData.length > 0) {

            setSectorData(sectorialIndicesData);

            const formatted = buildSectorChartData(sectorialIndicesData);

            // Step 1: set initial (0 height)
            setChartData(formatted);

            // Step 2: animate to actual height
            setTimeout(() => {
                setChartData(prev =>
                    prev.map(item => ({
                        ...item,
                        animatedHeight: Math.abs(item.value) * 90
                    }))
                );
            }, 100); // small delay for smooth animation
        }
    }, [sectorialIndicesData]);

    /* ================== UI ================== */
    return (
        <div className="sector-performance">
            <div className="sector-header">
                <h2 className="sector-heading">
                    <span className="sectorial-indices-span">SECTOR PERFORMANCE</span>
                </h2>
            </div>

            {/* CHART */}
            <div className="sector-chart">
                {chartData.map((item, index) => {
                    const isPositive = item.value >= 0;

                    return (
                        <div className="bar-wrapper" key={index}>

                            {/* VALUE */}
                            <div className="value">
                                {item.value > 0 ? "+" : ""}
                                {item.value.toFixed(2)}%
                            </div>

                            {/* BAR (ANIMATED) */}
                            <div
                                className={`bar ${isPositive ? "green" : "red"}`}
                                style={{
                                    height: `${item.animatedHeight}px`
                                }}
                            ></div>

                            {/* LABEL */}
                            <div className="label">{item.name}</div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
}